import React, { useRef } from 'react';
import useCtaBanner from 'hooks/useCtaBanner';

import s from './cta-cart-banner.module.scss';

export default function CtaCartBanner() {
  const banner = useRef();
  const { message, color } = useCtaBanner();

  return (
    <div className={`${s.root} ${s[color]}`} ref={banner}>
        <p>{message}</p>
    </div>
  );
}
